var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationProvider", {
        attrs: { rules: "required" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field input__wrap",
                    class: { "error-focus": errors.length > 0 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.companyName,
                          expression: "formData.companyName"
                        }
                      ],
                      staticClass: "login-form__field__input required",
                      class: {
                        error: errors.length > 0,
                        valid:
                          _vm.formData.companyName.length > 0 &&
                          errors.length == 0
                      },
                      attrs: {
                        id: "companyName",
                        type: "text",
                        name: "companyName",
                        required: ""
                      },
                      domProps: { value: _vm.formData.companyName },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.formData,
                              "companyName",
                              $event.target.value
                            )
                          },
                          _vm.onInput
                        ],
                        change: _vm.onChange
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_BUSINESS_NAME",
                          expression: "'INPUT_BUSINESS_NAME'"
                        }
                      ],
                      staticClass: "login-form__field__label",
                      attrs: { for: "companyName" }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c("div", { staticClass: "error-tooltip__wrap" }, [
                          _c("h4", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_BUSINESS_NAME_ERROR",
                                expression: "'INPUT_BUSINESS_NAME_ERROR'"
                              }
                            ],
                            staticClass:
                              "menu-link up-text error-tooltip__content"
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_BUSINESS_NAME_ERROR_DESCRIPTION",
                                expression:
                                  "'INPUT_BUSINESS_NAME_ERROR_DESCRIPTION'"
                              }
                            ],
                            staticClass: "description"
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: { rules: "required" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field input__wrap",
                    class: { "error-focus": errors.length > 0 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.firstName,
                          expression: "formData.firstName"
                        }
                      ],
                      staticClass: "login-form__field__input required",
                      class: {
                        error: errors.length > 0,
                        valid:
                          _vm.formData.firstName.length > 0 &&
                          errors.length == 0
                      },
                      attrs: {
                        id: "firstName",
                        type: "text",
                        name: "firstName",
                        required: ""
                      },
                      domProps: { value: _vm.formData.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.formData,
                            "firstName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_FIRST_NAME",
                          expression: "'INPUT_FIRST_NAME'"
                        }
                      ],
                      staticClass: "login-form__field__label",
                      attrs: { for: "firstName" }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c("div", { staticClass: "error-tooltip__wrap" }, [
                          _c("h4", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_FIRST_NAME_ERROR",
                                expression: "'INPUT_FIRST_NAME_ERROR'"
                              }
                            ],
                            staticClass:
                              "menu-link up-text error-tooltip__content"
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_FIRST_NAME_ERROR_DESCRIPTION",
                                expression:
                                  "'INPUT_FIRST_NAME_ERROR_DESCRIPTION'"
                              }
                            ],
                            staticClass: "description"
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: { rules: "required" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field input__wrap",
                    class: { "error-focus": errors.length > 0 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.lastName,
                          expression: "formData.lastName"
                        }
                      ],
                      staticClass: "login-form__field__input required",
                      class: {
                        error: errors.length > 0,
                        valid:
                          _vm.formData.lastName.length > 0 && errors.length == 0
                      },
                      attrs: {
                        id: "lastName",
                        type: "text",
                        name: "lastName",
                        required: ""
                      },
                      domProps: { value: _vm.formData.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.formData,
                            "lastName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_LAST_NAME",
                          expression: "'INPUT_LAST_NAME'"
                        }
                      ],
                      staticClass: "login-form__field__label",
                      attrs: { for: "lastName" }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c("div", { staticClass: "error-tooltip__wrap" }, [
                          _c("h4", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_LAST_NAME_ERROR",
                                expression: "'INPUT_LAST_NAME_ERROR'"
                              }
                            ],
                            staticClass:
                              "menu-link up-text error-tooltip__content"
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_LAST_NAME_ERROR_DESCRIPTION",
                                expression:
                                  "'INPUT_LAST_NAME_ERROR_DESCRIPTION'"
                              }
                            ],
                            staticClass: "description"
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ValidationProvider", {
        attrs: { rules: "required|email" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field input__wrap",
                    class: { "error-focus": errors.length > 0 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.email,
                          expression: "formData.email"
                        }
                      ],
                      ref: "emailInput",
                      staticClass: "login-form__field__input required",
                      class: {
                        error: errors.length > 0,
                        valid:
                          _vm.formData.email.length > 0 && errors.length == 0
                      },
                      attrs: {
                        id: "email",
                        type: "email",
                        name: "email",
                        required: ""
                      },
                      domProps: { value: _vm.formData.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.formData, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_EMAIL",
                          expression: "'INPUT_EMAIL'"
                        }
                      ],
                      staticClass: "login-form__field__label",
                      attrs: { for: "email" }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c("div", { staticClass: "error-tooltip__wrap" }, [
                          _c("h4", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_EMAIL_ERROR",
                                expression: "'INPUT_EMAIL_ERROR'"
                              }
                            ],
                            staticClass:
                              "menu-link up-text error-tooltip__content"
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_EMAIL_ERROR_DESCRIPTION",
                                expression: "'INPUT_EMAIL_ERROR_DESCRIPTION'"
                              }
                            ],
                            staticClass: "description"
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ValidationProvider", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ errors }) {
              return [
                _c(
                  "fieldset",
                  {
                    staticClass: "login-form__field input__wrap",
                    class: { "error-focus": errors.length > 0 }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formData.phoneNumber,
                          expression: "formData.phoneNumber"
                        }
                      ],
                      staticClass: "login-form__field__input required",
                      class: {
                        error: errors.length > 0,
                        valid:
                          _vm.formData.phoneNumber.length > 0 &&
                          errors.length == 0
                      },
                      attrs: {
                        id: "phoneNumber",
                        type: "text",
                        name: "phoneNumber"
                      },
                      domProps: { value: _vm.formData.phoneNumber },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.formData,
                            "phoneNumber",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "INPUT_PHONE_NUMBER",
                          expression: "'INPUT_PHONE_NUMBER'"
                        }
                      ],
                      staticClass: "login-form__field__label",
                      attrs: { for: "phoneNumber" }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c("div", { staticClass: "error-tooltip__wrap" }, [
                          _c("h4", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_PHONE_NUMBER_ERROR",
                                expression: "'INPUT_PHONE_NUMBER_ERROR'"
                              }
                            ],
                            staticClass:
                              "menu-link up-text error-tooltip__content"
                          }),
                          _vm._v(" "),
                          _c("p", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INPUT_PHONE_NUMBER_ERROR_DESCRIPTION",
                                expression:
                                  "'INPUT_PHONE_NUMBER_ERROR_DESCRIPTION'"
                              }
                            ],
                            staticClass: "description"
                          })
                        ])
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.orpDetails.requireAgreementToTerms
        ? _c("ValidationProvider", {
            attrs: { rules: { required: { allowFalse: false } } },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c(
                        "fieldset",
                        {
                          staticClass:
                            "login-form__field login-form__field--checkbox checkbox__wrap"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.agreedToTerms,
                                expression: "formData.agreedToTerms"
                              }
                            ],
                            staticClass: "login-form__field__input--checkbox",
                            attrs: {
                              id: "tos.checkbox",
                              type: "checkbox",
                              name: "tos.checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.formData.agreedToTerms)
                                ? _vm._i(_vm.formData.agreedToTerms, null) > -1
                                : _vm.formData.agreedToTerms
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.formData.agreedToTerms,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.formData,
                                        "agreedToTerms",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.formData,
                                        "agreedToTerms",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.formData, "agreedToTerms", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "login-form__field__label login-form__field__label--checkbox",
                              attrs: { for: "tos.checkbox" }
                            },
                            [
                              _vm.orpDetails.isTermsAndConditionsURL
                                ? _c(
                                    "span",
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(_vm.$t("PRP_TERMS_PREFIX")) +
                                          "  "
                                      ),
                                      _vm.termsLinkUrl
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.termsLinkUrl,
                                                target: "_BLANK"
                                              }
                                            },
                                            [
                                              _c("u", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("PRP_TERMS_LINK")
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : [
                                            _vm._v(
                                              _vm._s(_vm.$t("PRP_TERMS_LINK"))
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.orpDetails.isTermsAndConditionsURL
                                ? _c("span", [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.$t("PRP_TERMS_PREFIX")) +
                                        "  "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:;" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openTermsAndConditions()
                                          }
                                        }
                                      },
                                      [
                                        _c("u", [
                                          _vm._v(
                                            _vm._s(_vm.$t("PRP_TERMS_LINK"))
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "transition",
                            { attrs: { name: "backend-error-fade" } },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: errors.length > 0,
                                      expression: "errors.length > 0"
                                    }
                                  ],
                                  staticClass: "text-center p-t-5"
                                },
                                [
                                  _c("p", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "TERMS_EROR",
                                        expression: "'TERMS_EROR'"
                                      }
                                    ],
                                    staticClass: "text-danger"
                                  })
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              134244101
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }